export default __webpack_public_path__ + "static/media/61.76d01191.png";